import Sticky from './sticky'
import full from './full'

export default {
  install: (Vue) => {
    Vue.directive('sticky', Sticky)
    Vue.directive('full', full)
  }
}
